import React from 'react'

export const ButtonNormal = ({
    caption,
    onClick,
    disabled = false,
    loading = false,
    hideWhenDisabled = true,
}: {
    caption: string
    onClick: () => void
    disabled?: boolean
    loading?: boolean
    /** Si false, el botón se ve apagado en vez de desaparecer */
    hideWhenDisabled?: boolean
}) => {
    return (
        <button
            className={`px-3 py-1 bg-violetDark hover:bg-violet-600 text-base text-white whitespace-nowrap rounded-2xl flex items-center justify-center gap-2 disabled:cursor-not-allowed ${
                hideWhenDisabled ? 'disabled:hidden' : 'disabled:opacity-40'
            }`}
            onClick={onClick}
            disabled={disabled}
        >
            {loading ? <div className="spinner"></div> : null} {caption}
        </button>
    )
}
